module.exports = __webpack_public_path__ + "static/img/amd5.d54f1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd5.png
// module id = oChr
// module chunks = 1